import { lazy } from "react";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const AlertsPage = lazy(() => import(".."));

const alertsRoute = {
    name: "Alerts",
    link: "/alerts",
    path: "alerts",
    index: 9,
    element: <AlertsPage />,
    adminView: true,
    superAdminView: false,
    icon: NotificationsActiveIcon,
};

export default alertsRoute;
